import axios from "axios";

// Admin base path — change this single value to rename/relocate the admin portal.
export const ADMIN_BASE = "/gt-admin";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "gt_admin_token";
const USER_KEY = "gt_admin_user";

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function getUser() {
  try {
    return localStorage.getItem(USER_KEY) || "";
  } catch {
    return "";
  }
}

export function isAuthed() {
  return Boolean(getToken());
}

export function setSession(token, username) {
  localStorage.setItem(TOKEN_KEY, token);
  if (username) localStorage.setItem(USER_KEY, username);
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export const adminApi = axios.create({ baseURL: API_BASE });

adminApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      clearSession();
      if (!window.location.pathname.endsWith("/login")) {
        window.location.assign(`${ADMIN_BASE}/login`);
      }
    }
    return Promise.reject(err);
  }
);

export async function loginAdmin(username, password) {
  const { data } = await adminApi.post("/admin/login", { username, password });
  setSession(data.access_token, data.username);
  return data;
}

export async function fetchMe() {
  const { data } = await adminApi.get("/admin/me");
  return data;
}

export async function fetchStats() {
  const { data } = await adminApi.get("/admin/stats");
  return data;
}

export async function fetchContacts() {
  const { data } = await adminApi.get("/admin/contacts");
  return data;
}

export async function deleteContact(id) {
  await adminApi.delete(`/admin/contacts/${id}`);
}

export async function fetchConsultations() {
  const { data } = await adminApi.get("/admin/consultations");
  return data;
}

export async function deleteConsultation(id) {
  await adminApi.delete(`/admin/consultations/${id}`);
}

export async function fetchNewsletter() {
  const { data } = await adminApi.get("/admin/newsletter");
  return data;
}

export async function deleteNewsletter(id) {
  await adminApi.delete(`/admin/newsletter/${id}`);
}
